function AuthLoader() {
    const isAuth = sessionStorage.getItem('token')
    const { pathname } = window.location
    if(!isAuth && pathname != '/selfservice/invoice') {
        location.href = '/selfservice/invoice'
    }
    return {}
}

const route = [
    {
        path: "/selfservice/invoice",
        component: 'pc/Login'
    },
    {
        loader: AuthLoader,
        path: "/home",
        component: 'pc/Home'
    },
    {
        loader: AuthLoader,
        path:"/apply",
        component:'pc/InvoiceApply'
    },
    {
        loader: AuthLoader,
        path: '/query',
        component:'pc/InvoiceQuery'
    },
    {
        loader: AuthLoader,
        path:'/invoicesuccess',
        component: 'pc/InvoiceSuccess'
    },
    {
        loader: AuthLoader,
        path:'/invoicefail',
        component:'pc/InvoiceFail'
    },
    {
        path: "/",
        redirect:'/selfservice/invoice'
    }
]
export default route;
